import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'

export const getGameIframeUrlService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/ear-casino/game-launch', data, {
    server: microServices.SERVICE_URL_1
  })
}

// export const getGameIframeUrlService = (data) => {
//   return axiosInstanceService(
//     METHOD_TYPES.post,
//     '/ear-casino/game-launch',
//     data,
//     {
//       fullUrl: 'https://proxy.nextgenbets.com/game-launch'
//     }
//   )
// }



export const getProxiedIframeUrlService = (iframeUrl) => {
  return axiosInstanceService(
    METHOD_TYPES.get,
    '',
    {},
    {
      fullUrl: `https://proxy.nextgenbets.com/iframe?url=${encodeURIComponent(iframeUrl)}`
    }
  )
}

// Save URL and receive token
export const saveIframeUrlService = (targetUrl) => {
  return axiosInstanceService(
    METHOD_TYPES.post,
    null,
    { targetUrl },
    {
      fullUrl: 'https://proxy.nextgenbets.com/save-url',
      headers: { 'Content-Type': 'application/json' },
      handlerEnabled: false
    }
  );
};


export const getDemoGameIframeUrlService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/ear-casino/game-launch-demo', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getLiveTransactionsService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/system/wins', {}, {
    server: microServices.SERVICE_URL_1,
    params: data,
    loader: LOADER_HANDLER_TYPES.liveWins
  })
}

export const getHighRollerService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/casino/highrollers', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
